export default __webpack_public_path__ + "static/media/girl-in-the-red-dress.154ec28e.jpg";